
import { useEffect } from 'react'
import './style.scss'
import { useAppSelector } from '../../redux/hooks'


function DashboardReviewsContentArea() {

	const dataLoadRequestFinished: boolean = useAppSelector(state => state.user.dataLoadRequestFinished)

	// Setup test values
	useEffect(() => {
		// setTimeout(() => loadProfileData(), 200)
		if (dataLoadRequestFinished === true) {
		}
	}, [dataLoadRequestFinished])

	return (
		<div className='dashboard-content-area-wrap'>
			<div className='dashboard-content-area-wide-card-wrap'>
				<div className='dashboard-content-area-card'>
					<div className='dashboard-content-area-card-title-wrap'>
						<img
							className='dashboard-content-area-card-title-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-reviews.svg`}
							alt='Reviews symbol'
						/>
						<div className='dashboard-content-area-card-title-label'>Reviews</div>
					</div>
					<div
						className='dashboard-content-area-card-content'
					>
						<span>No Reviews</span>
					</div>
				</div>
			</div>
		</div>
	)
}

export default DashboardReviewsContentArea
